/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import './events.css';
import { Link } from 'react-router-dom';
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import { config } from '../config/config'; // eslint-disable-next-line
import { general } from '../config/config';
import Loader from '../common/Loader';
// eslint-disable-next-line
const History = (props) => {
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [commonLangugaeContent, setCommonLangugaeContent] = useState([]); // eslint-disable-next-line
	const [conferenceData, setConferenceData] = useState([]);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		getLanguagePack();
		getHistoryData();
		// eslint-disable-next-line
	}, []);

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setCommonLangugaeContent(response.data.WCS.AAA);
					}
					if (response?.data?.WCS?.HST) {
						setPageLanguageContent(response.data.WCS.HST);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.HST) {
				setPageLanguageContent(checkData?.HST);
			}
			if (checkData?.AAA) {
				setCommonLangugaeContent(checkData.AAA);
			}
		}
	}
	/* function to call api to get history events data */
	function getHistoryData() {
		setLoading(true);
		setConferenceData([]);
		copiriPortalRequest('/web/wcrmgl/overview/history', config.app_version, 'get')
			.then((response) => {
				setLoading(false);
				if (response.data.history && response.data.history.length > 0) {
					setConferenceData(response?.data?.history);
				}
			})
			.catch((error) => {
				setLoading(false);
			});
	}

	return (
		<>
			<div className='section-banner sbg-6 ptb-100'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-12'>
							<div className='banner-content'>
								<h2>{pageLanguageContent['HST001'] ? pageLanguageContent['HST001'] : ''}</h2>
								<nav aria-label='breadcrumb'>
									<ol className='breadcrumb'>
										<li className='breadcrumb-item'>
											<Link to='/'>{commonLangugaeContent['AAA001'] ? commonLangugaeContent['AAA001'] : ''} </Link>
										</li>
										<li className='breadcrumb-item active' aria-current='page'>
											{commonLangugaeContent['AAA002'] ? commonLangugaeContent['AAA002'] : ''}
										</li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			{loading ? (
				<Loader />
			) : (
				<div className='blog-section-2 ptb-100 conferenceEvents'>
					<div className='container'>
						<div className='row'>
							{conferenceData &&
								conferenceData.length > 0 &&
								// eslint-disable-next-line
								conferenceData.map((item, i) => (
									<div className='col-xl-4 col-sm-6' key={item?.id}>
										<Link to={`/event-details/history/${item?.id}`} className='btn-link'>
											<div className='blog-card grid'>
												<div className='blog-img imageLayout'>
													{item.logo ? (
														<img
															src={'../../assets/img/pages/' + item?.logo + '.webp'}
															alt='blog-1'
															className='trasnition '
														/>
													) : (
														<img src={general?.dark_logo} alt='blog-1' className='trasnition ' />
													)}
													<ul className='blog-metainfo'>
														<li>
															<i className='bx bx-calendar'></i>
															<span>{item?.numeral}</span>
														</li>
													</ul>
												</div>
												<div className='blog-info'>
													<h3>{item?.location}</h3>
													<ul className='blog-metainfo'>
														<li>
															<i className='bx bx-calendar'></i>
															{item?.date}
														</li>
													</ul>
													<span className='btn-link'>
														{pageLanguageContent['HST002'] ? pageLanguageContent['HST002'] : ''}
													</span>
												</div>
											</div>
										</Link>
									</div>
								))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default History;
